import React, { useState, useEffect } from 'react'
import { ToTopOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

//apis
import { getSuppliers } from 'apis/supplier'

export default function ExportProduct({ fileName, name, getProductsExport }) {
  const [suppliers, setSuppliers] = useState([])

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  const _getSuppliers = async () => {
    try {
      const res = await getSuppliers()
      if (res.status === 200) {
        setSuppliers(res.data.data)
      }
    } catch (error) {}
  }

  useEffect(() => {
    _getSuppliers()
  }, [])

  return (
    <Button
      onClick={async () => {
        const data = await getProductsExport()
        let dataExport = []

        data.map((e, index) => {
          const findSupplier = suppliers.find((s) => s.supplier_id === e.supplier_id)

          let objProduct = {
            STT: index + 1,
            'Tên món': e.name || '',
            'Tên phân loại món': e._categories ? e._categories.map((k) => k.name).join(', ') : '',
            'Tên nhà cung cấp': e._supplier ? e._supplier.name : '',
            'Hình ảnh': e.variants.length ? e.variants[0]?.image?.join(', ') : '',
            'Đơn vị tính': e.unit,
            Thuế: e._tax ? e._tax?.name : '',
            'Mô tả': e.description,
            'Giá trước thuế': e.variants[0].price_no_tax || 0,
            'Giá sau thuế': e.variants[0].price || 0,
          }
          dataExport.push(objProduct)
        })

        exportToCSV(dataExport, fileName)
      }}
      icon={<ToTopOutlined />}
      size="large"
      type="primary"
      style={{ minWidth: 130 }}
    >
      {name}
    </Button>
  )
}
